// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2_MmF","checkboxCol":"Table_checkboxCol__3ZvlN","emailCol":"Table_emailCol__T6-HF","actionCol":"Table_actionCol__1krlM"};